import logosvg from "../../images/logo.svg";
import React, { useState, useEffect } from "react";
import "./style.css";
import { Button } from "@material-tailwind/react";
import { Bars3Icon } from "@heroicons/react/20/solid";
import {
  Drawer,
  Card,
  List,
  Accordion,
  ListItem,
  AccordionHeader,
  ListItemPrefix,
  Typography,
  AccordionBody,
} from "@material-tailwind/react";
import {
  ChevronDownIcon,
  DocumentTextIcon,
  ChevronRightIcon,
  PhoneArrowUpRightIcon,
  Squares2X2Icon,
} from "@heroicons/react/20/solid";
import { API_URL } from "../constans/appConfig";
import { FaCoins, FaDollarSign } from "react-icons/fa";

export default function Navbar() {
  const [isMobile, setIsMobile] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [openCategoryId, setOpenCategoryId] = useState(
    sessionStorage.getItem("openCategoryId") || null
  );
  const [openSubcategoryId, setOpenSubcategoryId] = useState(
    sessionStorage.getItem("openSubcategoryId" || null)
  );
  const [goldPrice, setGoldPrice] = useState(null);
  const [diamondPrice, setDiamondPrice] = useState(null);

  const [categories, setCategories] = useState([]);
  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  const handleOpenCategory = (categoryId) => {
    setOpenCategoryId(openCategoryId === categoryId ? null : categoryId);
  };

  const handleOpenSubcategory = (subcategoryId) => {
    setOpenSubcategoryId(
      openSubcategoryId === subcategoryId ? null : subcategoryId
    );
  };

  const handleSelectSubcategory = (subcategoryId) => {
    window.location.href = `/products?subCategoryId=${subcategoryId}&&categoryId=${openCategoryId}`;
  };
  const handleSelectCategory = (categoryId) => {
    setOpenSubcategoryId(null);
    window.location.href = `/products?subCategoryId=null&&categoryId=${categoryId}`;
  };
  const getAllPrices = async () => {
    try {
      const response = await fetch(API_URL + "/price/getAllPrice");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      } else {
        const data = await response.json();
        const prices = data?.content || [];
        const goldPrice = prices.find((price) => price.priceId === "gram");
        const diamondPrice = prices.find((price) => price.priceId === "dolar");
        setGoldPrice(goldPrice);
        setDiamondPrice(diamondPrice);
      }
    } catch (error) {
      console.error("Failed to fetch prices:", error);
      // İsteğe bağlı olarak, kullanıcı dostu bir hata mesajı gösterin
    }
  };

  const getAllCategories = async () => {
    try {
      const response = await fetch(
        API_URL + "/fullCategory/getAllFullCategory"
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error("Failed to fetch categories:", error);
      // İsteğe bağlı olarak, kullanıcı dostu bir hata mesajı gösterin
    }
  };

  useEffect(() => {
    getAllCategories();
    getAllPrices();
  }, []);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 1220);
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="App font-[Inter]">
      {/* Fiyat Gösterge Kısmı */}
      <div className="bg-gradient-to-r from-[#E6C0B4] to-[#d4a898] shadow-md">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-end items-center gap-4 px-4 py-1.5">
            {/* Altın Fiyatı */}
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full">
              <FaCoins className="text-white text-xs" />
              <div className="flex items-center gap-1">
                <span className="text-white/80 text-xs font-medium">
                  Altın:
                </span>
                <span className="text-white font-semibold text-xs">
                  {goldPrice?.price} ₺
                </span>
              </div>
            </div>

            {/* Dolar Fiyatı */}
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full">
              <FaDollarSign className="text-white text-xs" />
              <div className="flex items-center gap-1">
                <span className="text-white/80 text-xs font-medium">
                  Dolar:
                </span>
                <span className="text-white font-semibold text-xs">
                  {diamondPrice?.price} ₺
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isMobile ? (
        <nav className="navbar px-4 flex flex-row justify-around w-full ">
          <a href="/">
            <img src={logosvg} alt="Logo" className="w-32" />
          </a>
          <div
            onMouseLeave={() => {
              setOpenCategoryId(null);
              setOpenSubcategoryId(null);
            }}
            className="flex flex-row"
          >
            {categories.map((category) => (
              <div
                key={category.categoryId}
                className="dropdown"
                style={{ position: "relative" }}
              >
                <div
                  className="nav-link dropdown-toggle cursor-pointer "
                  onMouseEnter={() => handleOpenCategory(category.categoryId)}
                  onClick={() => handleSelectCategory(category.categoryId)}
                >
                  {category.categoryName}
                </div>
                {openCategoryId === category.categoryId && (
                  <div
                    className="dropdown-menu"
                    style={{
                      display: "block",
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                      zIndex: 999,
                      minWidth: "200px",
                    }}
                    onMouseEnter={() => setOpenCategoryId(category.categoryId)}
                  >
                    <div className="submenu">
                      {category.subcategories.map((subcategory, index) => (
                        <div key={subcategory.subcategoryId}>
                          <div
                            className="nav-link subcategory-toggle cursor-pointer flex items-center flex-row"
                            onMouseEnter={() =>
                              handleOpenSubcategory(subcategory.subcategoryId)
                            }
                            onClick={() =>
                              handleSelectSubcategory(subcategory.subcategoryId)
                            }
                          >
                            {subcategory.subcategoryName}{" "}
                            {openSubcategoryId ===
                              subcategory.subcategoryId && (
                              <ChevronDownIcon className="w-4" />
                            )}
                          </div>

                          {/* Son alt kategori değilse bir ayar koyma */}
                          {index !== category.subcategories.length - 1 && (
                            <hr className="my-2 border-blue-gray-50" />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div>
            <a href="/aboutus" className="nav-link">
              HAKKIMIZDA
            </a>
            <a href="/contactus" className="nav-link">
              İLETİŞİM
            </a>
          </div>
        </nav>
      ) : (
        <div className="flex justify-between items-center w-full px-4 py-2 bg-white shadow-md">
          {/* Logo */}
          <a href="/" className="flex-shrink-0">
            <img src={logosvg} alt="Logo" className="w-24" />
          </a>

          {/* Menü Butonu */}
          <Button
            onClick={openDrawer}
            className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#E6C0B4] to-[#d4a898] shadow-md hover:shadow-lg transition-all duration-300"
          >
            <Bars3Icon className="h-5 w-5 text-white" />
            <span className="text-white text-sm font-medium">Menü</span>
          </Button>

          {/* Drawer içeriği */}
          <Drawer open={isDrawerOpen} onClose={closeDrawer} className="p-4">
            <Card className="h-full w-full bg-white rounded-xl shadow-none">
              <div className="mb-6 flex items-center justify-between p-4">
                <img src={logosvg} alt="Logo" className="w-24" />
                <Button
                  variant="text"
                  onClick={closeDrawer}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Button>
              </div>

              <List className="p-2">
                {categories.map((category) => (
                  <React.Fragment key={category.categoryId}>
                    {category.subcategories.length > 0 ? (
                      <Accordion
                        open={openCategoryId === category.categoryId}
                        icon={
                          <ChevronDownIcon
                            strokeWidth={2.5}
                            className={`mx-auto h-4 w-4 text-[#E6C0B4] transition-transform ${
                              openCategoryId === category.categoryId ? "rotate-180" : ""
                            }`}
                          />
                        }
                      >
                        <ListItem className="p-0 group hover:bg-[#E6C0B4]/5">
                          <AccordionHeader
                            onClick={() => handleOpenCategory(category.categoryId)}
                            className="border-b-0 p-3 transition-colors"
                          >
                            <ListItemPrefix>
                              <div className="w-8 h-8 rounded-lg bg-[#E6C0B4]/10 flex items-center justify-center group-hover:bg-[#E6C0B4]/20">
                                <Squares2X2Icon className="h-4 w-4 text-[#E6C0B4]" />
                              </div>
                            </ListItemPrefix>
                            <Typography color="blue-gray" className="mr-auto font-medium">
                              {category.categoryName}
                            </Typography>
                          </AccordionHeader>
                        </ListItem>
                        <AccordionBody className="py-1">
                          <List className="p-0">
                            <a
                              onClick={() =>
                                handleSelectCategory(category.categoryId)
                              }
                            >
                              <ListItem className="mr-auto font-normal font-[Inter] text-sm">
                                <ListItemPrefix>
                                  <ChevronRightIcon
                                    strokeWidth={3}
                                    className="h-3 w-5"
                                  />
                                </ListItemPrefix>
                                TÜMÜ
                              </ListItem>
                            </a>
                            {category.subcategories.map((subcategory) => (
                              <a
                                key={subcategory.subcategoryId}
                                onClick={() =>
                                  handleSelectSubcategory(
                                    subcategory.subcategoryId
                                  )
                                }
                              >
                                <ListItem className="mr-auto font-normal font-[Inter] text-sm">
                                  <ListItemPrefix>
                                    <ChevronRightIcon
                                      strokeWidth={3}
                                      className="h-3 w-5"
                                    />
                                  </ListItemPrefix>
                                  {subcategory.subcategoryName}
                                </ListItem>
                              </a>
                            ))}
                          </List>
                        </AccordionBody>
                      </Accordion>
                    ) : (
                      <ListItem
                        onClick={() => handleSelectCategory(category.categoryId)}
                        className="group hover:bg-[#E6C0B4]/5"
                      >
                        <ListItemPrefix>
                          <div className="w-8 h-8 rounded-lg bg-[#E6C0B4]/10 flex items-center justify-center group-hover:bg-[#E6C0B4]/20">
                            <Squares2X2Icon className="h-4 w-4 text-[#E6C0B4]" />
                          </div>
                        </ListItemPrefix>
                        {category.categoryName}
                      </ListItem>
                    )}
                  </React.Fragment>
                ))}

                <hr className="my-4 border-gray-200" />

                {/* Hakkımızda Butonu */}
                <a href="/aboutus">
                  <ListItem className="group hover:bg-[#E6C0B4]/5">
                    <ListItemPrefix>
                      <div className="w-8 h-8 rounded-lg bg-[#E6C0B4]/10 flex items-center justify-center group-hover:bg-[#E6C0B4]/20">
                        <DocumentTextIcon className="h-4 w-4 text-[#E6C0B4]" />
                      </div>
                    </ListItemPrefix>
                    <span className="font-medium">HAKKIMIZDA</span>
                  </ListItem>
                </a>

                {/* İletişim Butonu */}
                <a href="/contactus">
                  <ListItem className="group hover:bg-[#E6C0B4]/5">
                    <ListItemPrefix>
                      <div className="w-8 h-8 rounded-lg bg-[#E6C0B4]/10 flex items-center justify-center group-hover:bg-[#E6C0B4]/20">
                        <PhoneArrowUpRightIcon className="h-4 w-4 text-[#E6C0B4]" />
                      </div>
                    </ListItemPrefix>
                    <span className="font-medium">İLETİŞİM</span>
                  </ListItem>
                </a>
              </List>
            </Card>
          </Drawer>
        </div>
      )}
    </div>
  );
}
